module.exports = __webpack_public_path__ + "img/withdrawal.d155f65b.svg";